import axios from 'axios';
import {
  BenefitDetailUrl,
  BenefitHospitalNetworkUrl,
  BenefitInsuraceCardUrl,
  BenefitInsuracePolicyCardUrl,
  DownloadCertificateURL,
  DownloadNpsTransactionStatementUrl,
  GAPDetailUrl,
  LinkedManufacturesUrl,
  MyBenefitsUrl,
  OverviewDetailsUrl,
  ShopInsuranceCardUrl,
  ShopInsuranceDetailUrl,
  StaffDetailUrl,
  staffInsuranceCardUrl,
  TDSDetailUrl,
} from '../url';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { toast } from 'react-toastify';

export const LinkedManufacturesAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${LinkedManufacturesUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const OverViewDetailAction = async (manufacturerId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const params = {
      manufacturer_id: manufacturerId,
    };
    await axios
      .get(OverviewDetailsUrl(), { ...getTokenHeader(token), params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const MyBenefitsAction = async (manufacturerId, company_esi_id ) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${MyBenefitsUrl()}?manufacturer_id=${manufacturerId}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const BenefitDetailAction = async (manufacturerId,insuranceId, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${BenefitDetailUrl()}?manufacturer_id=${manufacturerId}&insurance_type=${insuranceId}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const StaffDetailAction = async (manufacturerId,company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${StaffDetailUrl()}?manufacturer_id=${manufacturerId}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GAPDetailAction = async (manufacturerId, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GAPDetailUrl()}?manufacturer_id=${manufacturerId}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const ShopInsuranceDetailAction = async (manufacturerId, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${ShopInsuranceDetailUrl()}?manufacturer_id=${manufacturerId}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const TDSDetailAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${TDSDetailUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const downloadCertificate = async (period_start_date, period_end_date, file_name) => {
  try {
    // Get authentication token
    let token = await getToken();
    const queryParams = new URLSearchParams();
    queryParams.append('period_start_date', period_start_date);
    queryParams.append('period_end_date', period_end_date);
    const url = `${DownloadCertificateURL()}?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: 'GET',
      ...getTokenHeader(token),
    });
    const blob = await response.blob();
    
    if (blob.type.includes('application/json')) {
      const displayName = file_name.replace('.pdf', '');
      toast.error(`No ${displayName} Found`);
      return Promise.reject(new Error(`No ${displayName} Found`));
    }
    const isAndroidWebView = /Android/i.test(navigator.userAgent) && window.navigator.userAgent.includes('wv');
    
    if (isAndroidWebView) {
      return downloadFileInAndroid(blob, file_name);
    } else {
      return downloadFileInBrowser(blob, file_name);
    }
  } catch (err) {
    console.error('Download error:', err);
    toast.error('Download failed. Please try again.');
    return Promise.reject(err);
  }
};

export const downloadPolicyCardAction = async (insuranceType, file_name) => {
  try {
    // Get authentication token
    let token = await getToken();
    
    // Fetch the file
    const response = await fetch(`${BenefitInsuracePolicyCardUrl()}?insurance_type=${insuranceType}`, {
      method: 'GET',
      ...getTokenHeader(token),
    });
    
    // Convert response to blob
    const blob = await response.blob();
    
    // Check if the response is an error message
    if (blob.type.includes('application/json')) {
      return toast.error('No E-card Found');
    }
    
    // Detect if we're running in Android WebView
    const isAndroidWebView = /Android/i.test(navigator.userAgent) && window.navigator.userAgent.includes('wv');
    
    // Handle download based on environment
    if (isAndroidWebView) {
      return downloadFileInAndroid(blob, file_name);
    } else {
      return downloadFileInBrowser(blob, file_name);
    }
  } catch (err) {
    console.error('Download error:', err);
    toast.error('Download failed. Please try again.');
    return Promise.reject(err);
  }
};

// Helper function to download file in Android WebView
export const downloadFileInAndroid = (blob, fileName) => {
  return new Promise((resolve, reject) => {
    try {
      // Create a direct blob URL for downloadUrl method
      const blobUrl = URL.createObjectURL(blob);
      
      // Check for downloadUrl method first (preferred)
      if (window.AndroidInterface && typeof window.AndroidInterface.downloadUrl === 'function') {
        console.log('Using AndroidInterface.downloadUrl for download');
        window.AndroidInterface.downloadUrl(blobUrl, fileName);
        resolve();
        return;
      }
      
      // If downloadUrl is not available, try downloadFile with base64 as fallback
      if (window.AndroidInterface && typeof window.AndroidInterface.downloadFile === 'function') {
        console.log('Using AndroidInterface.downloadFile for download');
        
        // Convert blob to base64 string
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        
        reader.onloadend = function() {
          try {
            const base64data = reader.result;
            window.AndroidInterface.downloadFile(base64data, fileName, blob.type, blobUrl);
            resolve();
          } catch (e) {
            console.error('Error in Android download:', e);
            toast.error('Download failed: ' + (e.message || 'Unknown error'));
            reject(e);
          }
        };
        
        reader.onerror = function(error) {
          console.error('Error reading file:', error);
          toast.error('Failed to prepare download');
          reject(error);
        };
        
        return;
      }
      
      // If no Android interface is available, try direct navigation to the blob URL
      console.log('AndroidInterface not available, trying direct blob URL navigation');
      window.location.href = blobUrl;
      resolve();
      
    } catch (e) {
      console.error('Error in Android download:', e);
      toast.error('Download failed: ' + (e.message || 'Unknown error'));
      reject(e);
    }
  });
};

// Helper function to download file in regular browsers
export const downloadFileInBrowser = (blob, fileName) => {
  // Direct download for browsers
  directDownload(blob, fileName);
  return Promise.resolve();
};

// Helper function for direct download using Blob URL
const directDownload = (blob, fileName) => {
  try {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // Clean up
  } catch (e) {
    console.error('Error in direct download:', e);
  }
};

export const downloadNpsTransactionStatementAction = async (company_esi_id, manufacturer_id, file_name) => {
  try {
    let token = await getToken();

    const queryParams = new URLSearchParams();
    queryParams.append('company_esi_id', company_esi_id);
    queryParams.append('manufacturer_id', manufacturer_id);

    const url = `${DownloadNpsTransactionStatementUrl()}?${queryParams.toString()}`;

    const response = await fetch(url, {
      method: 'GET',
      ...getTokenHeader(token),
    });

    const blob = await response.blob();

    if (blob.type.includes('application/json')) {
      const displayName = file_name.replace('.pdf', '');
      toast.error(`No ${displayName} Found`);
      return Promise.reject(new Error(`No ${displayName} Found`));
    }

    const isAndroidWebView = /Android/i.test(navigator.userAgent) && window.navigator.userAgent.includes('wv');

    if (isAndroidWebView) {
      await downloadFileInAndroid(blob, file_name);
    } else {
      await downloadFileInBrowser(blob, file_name);
    }
    toast.success('File downloaded successfully');
  } catch (err) {
    console.error('Download error:', err);
    toast.error('Download failed. Please try again.');
    return Promise.reject(err);
  }
};

//Hospital Network Action
export const BenefitHospitalNetworkAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${BenefitHospitalNetworkUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};